export function formatNameLastFirst(fullName: string): string {
  const trimmed = fullName.trim().replace(/\s+/g, " ");
  if (!trimmed) return "";
  const lastSpace = trimmed.lastIndexOf(" ");
  if (lastSpace === -1) return trimmed;
  const last = trimmed.slice(lastSpace + 1);
  const rest = trimmed.slice(0, lastSpace);
  return `${last}, ${rest}`;
}

function lastNameOf(name: string): string {
  const trimmed = name.trim().replace(/\s+/g, " ");
  const lastSpace = trimmed.lastIndexOf(" ");
  return lastSpace === -1 ? trimmed : trimmed.slice(lastSpace + 1);
}

export function compareUsersByLastName<T extends { name: string }>(a: T, b: T): number {
  const aLast = lastNameOf(a.name).toLocaleLowerCase();
  const bLast = lastNameOf(b.name).toLocaleLowerCase();
  if (aLast !== bLast) return aLast < bLast ? -1 : 1;
  const aFull = a.name.toLocaleLowerCase();
  const bFull = b.name.toLocaleLowerCase();
  if (aFull === bFull) return 0;
  return aFull < bFull ? -1 : 1;
}
